import { frontendURL } from '../../../helper/URLHelper';

const FlowsV2ListView = () => import('./FlowsV2ListView.vue');
const FlowBuilderView = () => import('./FlowBuilderView.vue');
const CannedResponsesView = () => import('./CannedResponsesView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/flujos-v2'),
      name: 'flows_v2_list',
      component: FlowsV2ListView,
      meta: { permissions: ['administrator', 'module_flows'] },
    },
    // Va ANTES de la ruta con :flowId, o "respuestas" se interpretaría como
    // el identificador de un flujo y abriría el constructor en blanco.
    {
      path: frontendURL('accounts/:accountId/flujos-v2/respuestas'),
      name: 'flows_v2_canned',
      component: CannedResponsesView,
      meta: { permissions: ['administrator', 'agent', 'module_flows'] },
    },
    {
      path: frontendURL('accounts/:accountId/flujos-v2/:flowId'),
      name: 'flows_v2_builder',
      component: FlowBuilderView,
      meta: { permissions: ['administrator', 'module_flows'] },
    },
  ],
};
